module.exports = __webpack_public_path__ + "static/media/private-event02.2123b1b8.jpg";